import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AuthorizationGrid from '../authorization';
import MessageGrid from '../messageGrid';
import ApiService from '../../../services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import RequisitionItemList from './itemlist';
import { FaAngleLeft } from "react-icons/fa6";
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import { getCompany } from '../../../../Redux/selecters';
import { useSelector } from 'react-redux';

const PurchaseRequisitionView = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const [requsitionData, setPR] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const currentDatetimeUTC = new Date().toISOString();
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const location = useLocation();
    const { currencyPrecision } = useCurrency();
    const [isXtreamCompany, setXtreamCompany] = useState(false);
    const Company = useSelector(getCompany);

    const itemData = location.state;
    const [SupplierTab, setSupplierTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const todayDate = new Date().toISOString().substr(0, 10);
    const [formData, setFormData] = useState({
        recordId: "",
        requisitionNo: "",
        itemType: "",
        quatotionNo: "",
        remarks: "",
        deliveryNote: "",
        requestor: "",
        requisitionDate: currentDatetimeUTC,
        deliveryDate: todayDate,
        currencyCode: "",
        exchangeRate: "",
        department: [],
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        deliveryPoint: "",
        location: "",
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
    });
    useEffect(() => {
        getApprovalUser()
    }, [])
    useEffect(() => {
        const item = location.state;
        const SetData = async () => {
            try {
                if (currencyPrecision) {
                    setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
                }
                let param = `?Id=${item?.docno || item?.requisitionNo}`
                const response = await apiService.getApiParamater('GET_PR', param);
                let selectedPr = response?.data?.result?.[0]
                setPR(selectedPr)

                setFormData({
                    recordId: item.docno,
                    requisitionDate: selectedPr?.requisitionDate || currentDatetimeUTC,
                    deliveryDate: selectedPr?.deliveryDate ? selectedPr.deliveryDate.substr(0, 10) : todayDate,
                    requisitionNo: selectedPr?.requisitionNo,
                    quatotionNo: selectedPr?.contractNo,
                    remarks: selectedPr?.remarks,
                    requestor: selectedPr?.requestor,
                    exchangeRate: currencyPrecision?.exchangeRate,
                    itemType: { label: selectedPr?.type, value: selectedPr?.type },
                    currencyCode: { label: selectedPr?.currencyCode, value: selectedPr?.currencyCode },
                    costCenter1: { label: selectedPr?.costCenter1, value: selectedPr?.costCenter1 },
                    costCenter2: { label: selectedPr?.costCenter2, value: selectedPr?.costCenter2 },
                    costCenter3: { label: selectedPr?.costCenter3, value: selectedPr?.costCenter3 },
                    costCenter4: { label: selectedPr?.costCenter4, value: selectedPr?.costCenter4 },
                    jobNo: { label: selectedPr?.costCenter5, value: selectedPr?.costCenter5 },
                    deliveryPoint: selectedPr?.deliveryPoint,
                    contactPerson: selectedPr?.contactPerson,
                    contatNo: selectedPr?.contatNo,
                    taskCode: selectedPr?.projectCode,
                    location: selectedPr?.location,
                    deliveryNote: selectedPr?.boq,
                });
                setSelectedLocation({ label: selectedPr.approvalUser, value: selectedPr?.approvalUser })
                setSelectedDepartment({ label: selectedPr.department, value: selectedPr?.department })
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (item) {
            SetData()
        }
    }, [location?.state, itemData]);

    useEffect(() => {
        checkCompanyName();
    }, [Company]);
    const getApprovalUser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('DocNo', itemData?.requisitionNo || itemData?.docno);
            params.append('DocumentType', itemData?.reqType);

            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
            let attachparam = `?DocNo=${itemData?.requisitionNo || itemData?.docno}&DocType=${"Requisition"}`
            const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
            setAttachmentList(AttachmentResponse?.data?.result || [{ id: Date.now(), fileName: '', remarks: '' }])
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        console.log(data, 'reqData')
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleView = (file) => {
        if (file) {
            setPreviewImage(file);
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };

    const checkCompanyName = () => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find(comp => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toLowerCase() || '';
        const isXtreamCashier = companyName.includes('accountcode') || companyName.includes('kanoo');
        setXtreamCompany(isXtreamCashier);
    };
    return (
        <div className='p-4'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Purchase Requisition</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Requisition Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="recordId" className="form-label  pt-2 start">Requisition No</label>
                                <input
                                    className="form-Input w-70"
                                    disabled
                                    value={formData.recordId || itemData.requisitionNo}
                                    name="recordId"
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Delivery Date</label>
                                <input
                                    type='date'
                                    className='form-Input w-70' disabled
                                    value={formData.deliveryDate}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Location</label>
                                <Select isDisabled value={selectedLocation}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Date </label>
                                <input
                                    className='form-Input w-70'
                                    type='date' disabled
                                    defaultValue={new Date().toISOString().substr(0, 10)}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Delivery Point</label>
                                <input disabled
                                    className="form-Input w-70"
                                    value={formData.deliveryPoint}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Copy Request</label>
                                <Select isDisabled
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Currency</label>
                                <Select isDisabled value={formData?.currencyCode}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="location" className="form-label  pt-2 start">Location *</label>
                                <input disabled value={formData.location} className="form-Input w-70" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Quotation No</label>
                                <Select isDisabled
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="exchangeRate" className="form-label  pt-2 start">Exchange Rate</label>
                                <input disabled value={formData.exchangeRate} className="form-Input w-70" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="contactPerson" className="form-label  pt-2 start">Contact Person</label>
                                <input disabled value={formData.contactPerson} className="form-Input w-70" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="requestor" className="form-label  pt-2 start">Requester</label>
                                <input disabled className="form-Input w-70" value={formData.requestor} />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Item Type</label>
                                <Select isDisabled
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    value={formData?.itemType}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="contatNo" className="form-label  pt-2 start">Contact No</label>
                                <input disabled className="form-Input w-70" value={formData.contatNo} />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="department" className="form-label  pt-2 start">Department</label>
                                <Select isDisabled value={selectedDepartment}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="department" className="form-label  pt-2 start">Task Code</label>
                                <Select isDisabled
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Remarks</label>
                                <input disabled
                                    className="form-Input w-70"
                                    value={formData.remarks}
                                />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="BuyerName" className="form-label center">Delivery Note No</label>
                                <input
                                    type="text" disabled
                                    className="form-Input w-70"
                                    id="deliveryNote"
                                    name="deliveryNote"
                                    value={formData?.deliveryNote}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setCostTab(!CostTab)}>
                    <div className='h6 pt-1'>Cost Center</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                <Select isDisabled value={formData.costCenter1}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col-4 d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Unit</label>
                                <Select isDisabled value={formData.costCenter2}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col-4 d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 3" : "Nature of Job"}</label>
                                <Select isDisabled value={formData.costCenter3}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col-4 mt-2 d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 4" : "Work Order No"}</label>
                                <Select isDisabled value={formData.costCenter4}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" />
                            </div>
                            <div className="col-4 mt-2 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Job No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    isDisabled
                                    value={formData.jobNo}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`cost-center-section`}>
                <div className="mt-3 cursor-pointer slide-header">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Requisition
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className={`slide-content open`}>
                <div className={`grid-1 border-box2 p-3`}>
                    {gridVisibility[0] && (
                        <RequisitionItemList itemData={requsitionData} selectedLocation={selectedLocation}
                            precision={currencyPrecision?.precision} />
                    )}
                    {gridVisibility[1] && (
                        <AuthorizationGrid
                            handleAuthorization={handleAuthorization}
                            usersDetails={usersDetails}
                            setUser={setUser}
                            itemData={formData}
                        />
                    )}
                    {gridVisibility[2] && (
                        <div className="grid-3 border">
                            <MessageGrid handleMessage={handleMessage} />
                        </div>
                    )}
                </div>
            </div>
            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={formData.recordId} className="form-Input w-70" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList?.map((attachment, index) => (
                                        <tr key={attachment.id}>
                                            <td className='m-0 p-0'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "320px" }} /></td>
                                            <td>
                                                <input type="text" value={attachment.remarks} disabled
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                                <input
                                                    type="file" accept="image/*" disabled
                                                    style={{ display: 'none' }}
                                                    id={`fileInput-${attachment.id}`}
                                                />
                                            </td>
                                            <td><button className='mainbtnRed ' onClick={() => handleView(attachment.fileName)} disabled={!attachment.fileName}>
                                                <div>View</div></button></td>
                                            <td>
                                                <button disabled={true} className='mainbtnSecondary'>
                                                    <div>Delete</div></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn ' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {previewImage && <img src={"https://procapi.pro360dev.freemyip.com/Resources/" + previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
}

export default PurchaseRequisitionView